import { Badge, Flex, Typography } from 'antd';
import styled from 'styled-components';
import { SmileOutlined } from '@ant-design/icons';

export const TitleNoMargin = styled(Typography.Title).attrs({
  style: {
    marginBottom: 0,
  },
})`
  display: inline-flex;
  gap: 8px;
  align-items: center;
`;

export const NotificationsPopoverContent = styled(Flex).attrs({
  vertical: true,
})`
  width: 450px;
`;

export const HeaderWrapper = styled(Flex).attrs({
  justify: 'space-between',
  align: 'center',
})`
  border-bottom: 1px solid ${({ theme }) => theme.colorBorderSecondary};
  padding: 16px 20px;
`;

export const FooterWrapper = styled(Flex).attrs({
  justify: 'flex-end',
})`
  padding: 12px 24px;
  button {
    color: ${({ theme }) => theme.colorPrimary};
  }
`;

export const SmileOutlinedIcon = styled(SmileOutlined)`
  svg {
    color: ${({ theme }) => theme.colorTextTertiary};
  }
`;

export const EmptyNotifications = styled(Flex).attrs({
  vertical: true,
  align: 'center',
  justify: 'center',
  gap: 8,
})`
  height: 124px;
`;

export const StyledBadge = styled(Badge)`
  sup {
    margin-top: 5px;
    margin-right: 5px;
  }
`;
